/* eslint-disable */
import { useState, useEffect, useRef } from "react";
import { Grid, GridColumn, getSelectedState } from "@progress/kendo-react-grid";
import * as API from "../API/api";
import { MyToggleButton } from "./helpercomponents/CustomGridCells/MyToggleButton"
import { DateCell, DateOnlyCell, LocalDateTimeColumn } from "../forms/helpercomponents/CustomGridCells/DateCell";
import { LookupCell } from "../forms/helpercomponents/CustomGridCells/LookupCell";
import { ImageCell } from "./helpercomponents/CustomGridCells/ImageCell";
import EditForm from "./helpercomponents/editForm";
import { COLUMNSTYPE, ENTITYNAME, LOCALSTORAGE_KEY, MODULE, FILEURL, DELIVERYSTATUSENUM, SOCKET_EVENTS, SOCKET_ACTION, LOGEVENT, UPCOMING_EVENTS_MONTHS, ROLETYPE, MEDIA_TRANSMISSION, MAM_STATUS, TEMPLATENAME, TOAST_TYPES } from "../constant/constant";
import { useLocation, useNavigate } from "react-router-dom";
import DeleteErrorDialogBox from "./helpercomponents/alert/DeleteErrorDialogBox";
import { MenuCommandCell } from "./helpercomponents/CustomGridCells/MenuCommandCell ";
import { TimeCell } from "./helpercomponents/CustomGridCells/TimeCell";
import { collectionMenuModel } from "./helpercomponents/contextMenu/menus/collectionMenuModel";
import { UserPreference } from "../../modules/userPreference/UserPreference";
import { utility } from "../utility/utilityProvider";
import { ArrayCell } from "./helpercomponents/CustomGridCells/ArrayCell";
import { CheckboxCell } from "./helpercomponents/CustomGridCells/CheckBoxCell";
import { HrefCell, HyperLinkCell } from "./helpercomponents/CustomGridCells/HrefCell";
import { useTranslation } from "../../locale/useTranslation";
import BackRoundButton from "./helpercomponents/buttons/BackRoundButton";
import AddRoundButton from "./helpercomponents/buttons/AddRoundButton";
import RefreshButton from "./helpercomponents/buttons/RefreshButton";
import PreferenceRoundButton from "./helpercomponents/buttons/PreferenceRoundButton";
import { EnumCell } from "./helpercomponents/CustomGridCells/EnumCell";
import RoundButton from "./helpercomponents/buttons/RoundButton";
import { PlatformCell, arrayEnumCell, daysCell } from "./helpercomponents/CustomGridCells/PlatformCell";
import MyStatusCell from "../../components/MyStatusCell";
import { IconCell } from "./helpercomponents/CustomGridCells/IconCell";
import socket from "../socket/socket";
import { getter } from "@progress/kendo-data-query";
import ActionButton from "./helpercomponents/buttons/ActionButton";
import { Loader } from "./helpercomponents/Loader";
import { colorCell } from "./helpercomponents/CustomGridCells/ColorCell";
import BossDialog from "../../components/BossDialog";
import { MediaFilterTemplate } from "../../modules/Planning/MediaFilterTemplate";
import { MultiLangArrayCell } from "./helpercomponents/CustomGridCells/MultiLangArrayCell";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { ContentArrayImageCell } from "./helpercomponents/CustomGridCells/ContentArrayImageCell";
import { TextWithIconCell } from "./helpercomponents/CustomGridCells/TextWithIconCell";
import castTypeCell from "./helpercomponents/CustomGridCells/CastTypeCell";
import CollectionSelection from "./CollectionSelection";
import { MediaMamAssetColumns } from "../utility/customColumns";
import { ConfirmAlert, ConfirmDeleteAlert } from "../../ConfirmAlert";
import DeleteRoundButton from "./helpercomponents/buttons/DeleteRoundButton";
import { DataHelper } from "../helper/DataHelper";
import { EditPageHeader } from "../../components/EditPageHeader";
// import MediaEpisodeIngestMAMPopup from "../../modules/Segment/MediaEpisodeIngestMAMPopup";
import MAMStatusCell from "../../components/MAMStatusCell";
import MamAssetShowAttachedMediaForm from "../../modules/MediaLibrary/MamAssetShowAttachedMediaForm";
import { ContextMenu } from "primereact/contextmenu";
import PrototypeDialog from "./prototypeDialog";
import ToastNotification from "../../components/ToastNotification";

//entityname is table name
// filterable = false
// sortable = false
// pageable = false
// take = 10
//showEdit = true
//showTitle = true

const SELECTED_FIELD = "selected";
const DATA_ITEM_KEY = "_id";
const idGetter = getter(DATA_ITEM_KEY);

export const MamAssetCollection = (props) => {

    const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);
    const isEtisalat = company && company.Name && company.Name.toLowerCase() == "etisalat";

    //possible props
    let page_take = props.page_take ?? 50;
    let showAdd = props.showAdd ?? true;
    let showBack = props.showBack ?? true;
    let showImport = props.showImport ?? false;
    let showExport = props.showExport ?? true;
    let showArchive = props.showArchive ?? true;
    let showCommandCell = props.showCommandCell ?? true;
    let showEdit = props.showEdit ?? true;
    let showDelete = props.showDelete ?? true;
    let showTitle = props.showTitle ?? true;
    let gridRowRender = props.gridRowRender;
    let CustomEditForm = props.customEditForm ?? EditForm;
    let filterable = props.filterable ?? false;
    let sortable = props.sortable ?? true;
    let isPageable = props.isPageable ?? true;
    let wherestatement = props.wherestatement ?? [];
    let andWhereStatement = props.andWhereStatement ?? [];
    let sort = props.sort ?? { SID: 1 };
    let customColumns = props.customColumns ?? [];
    let openNewEditForm = props.openNewEditForm ?? false;
    let myTitle = props.title ?? "";
    let myMenuModel = props.menuModel ?? collectionMenuModel;
    let entityName = props.entityname;
    let showPreferenceButton = props.showPreferenceButton ?? true;
    let hideArchiveProps = props.hideArchive ?? false;
    let showFilterTemplate = props.showFilterTemplate ?? false;
    let enableMutliSelect = props.enableMutliSelect ?? false;
    let module = props?.module;
    let showLogs = props.showLogs ?? true;
    let doLoad = props.isLoading ?? true;
    let showSyncMaMAsset = props.showSyncMaMAsset ?? false;
    let isTieredMenu = props.isTieredMenu ?? false;
    let showLangDropdown = props.showLangDropdown ?? true;

    //Currently Confirgured For Etisalat
    let showSyncWithS3MaMAsset = isEtisalat ? true : props.showSyncWithS3MaMAsset ?? false;

    //Add this for media management preference column
    const preferenceColumnENntityName = props.preferenceEntityName && props.preferenceEntityName.length > 0 ? props.preferenceEntityName : entityName;
    // example custome columns[]
    const [gridData, setGridData] = useState([]);
    const [total, setTotal] = useState(1);
    const [openForm, setOpenForm] = useState(false);
    const [editItem, setEditItem] = useState({ SID: 1 });
    const [warningDialog, setWarningDialog] = useState(false);
    const [deleteError, setDeleteError] = useState(false);
    const [deleteErrorMessage, setDeleteErrorMessage] = useState("");
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [isNoRecords, setIsNoRecords] = useState(false);
    const [showPreferences, setShowPreferences] = useState(false);
    const [dataColumns, setDataColumns] = useState([]);
    const [searchText, setSearchText] = useState(null);
    const [showArchived, setShowArchived] = useState(false);
    const [showMoveToMediaPopup, setShowMoveToMediaPopup] = useState(false);
    const [showMamAssetCollectionSelection, setShowMamAssetCollectionSelection] = useState(false);
    const [dataItem, setDataItem] = useState([]);
    const fileRef = useRef(null);

    const [hideArchive] = useState(hideArchiveProps);
    const [selectedState, setSelectedState] = useState({});
    const [filterTemplate, setFilterTemplate] = useState([]);
    const initialSort = { field: Object.keys(sort)[0], dir: sort[Object.keys(sort)[0]] == 1 ? "asc" : "desc" }
    const [gridSort, setGridSort] = useState([initialSort]);

    const [selectedMamAssets, setSelectedMamAssets] = useState([]);
    const [mediaCategories, setMediaCategories] = useState([]);
    const [mediaCategoryTypes, setMediaCategoryTypes] = useState([]);
    const [contents, setContents] = useState([]);

    const [selectedMamStatus, setSelectedMamStatus] = useState(null);
    const mamStatusList = [{ _id: null, Description: "All" }, ...Object.keys(MAM_STATUS).map((key) => ({ _id: MAM_STATUS[key], Description: key }))];

    const [showSelectTransmissionTypePopup, setShowSelectTransmissionTypePopup] = useState(false);

    const [showTranscodePrototypePopup, setShowTranscodePrototypePopup] = useState(false);
    const [ingestPrototypes, setIngestPrototypes] = useState([]);
    const ingestPrototypeRef = useRef(null);
    const [ingestPrototype, _setIngestPrototype] = useState({});
    const [attachedIngestPrototype, setAttachedIngestPrototype] = useState(null);
    const [transcodePrototypes, setTrancodePrototypes] = useState([]);
    const transcodePrototypeRef = useRef(null);
    const [transcodePrototype, _setTranscodePrototype] = useState({});
    const [attachedTranscodePrototype, setAttachedTranscodePrototype] = useState(null);
    const [showAttachedMedia, setShowAttachedMedia] = useState(false);
    const [publishResults, setPublishResults] = useState([]);
    const [showPublishResultsPopup, setShowPublishResultsPopup] = useState(false);
    const [publishResultsTitle, setPublishResultsTitle] = useState("Work Order Results");
    const setTranscodePrototype = (data) => {
        _setTranscodePrototype(data);
        transcodePrototypeRef.current = data;
    }
    const setIngestPrototype = (data) => {
        _setIngestPrototype(data);
        ingestPrototypeRef.current = data;
    }

    const handleMamStatusChange = (e) => {
        const selectedItem = e.target.value;
        setSelectedMamStatus(selectedItem);
        setDataItem({ ...dataItem, MamStatus: selectedItem?._id ?? null });
        let filterQuery = [];

        if (selectedItem?._id !== null && selectedItem?._id > 1) {
            filterQuery = [["Status", "=", selectedItem._id]];
        }
        else if (selectedItem?._id === 1) {
            filterQuery = [
                ["Status", "!=", MAM_STATUS.Ingested], "and",
                ["Status", "!=", MAM_STATUS.TXReady], "and",
                ["Status", "!=", MAM_STATUS.Transcoding]
            ];
        }
        loaddata({ per_page: page.take, current_page: 1, orderby: "SID", direction: "asc" }, wherestatement, andWhereStatement, searchText, showArchived, filterQuery);

    };

    const selectedItemsRef = useRef([]);
    const setSelectedItem = (items) => {
        selectedItemsRef.current = items;
    }

    const gridRef = useRef(null);
    const menuRef = useRef(null);

    const [page, setPage] = useState({
        skip: 0,
        take: page_take,
    });

    const loc = useLocation();
    const lang = useTranslation();

    const urlParams = new URLSearchParams(location?.search ?? "");
    let mamID = urlParams?.get('mamID');
    const mamStatus = urlParams?.get('status');
    if (mamStatus) {
        wherestatement = [...wherestatement, ['Status', '=', parseInt(mamStatus)]];
    }
    const paramQuery = {
        curPage: parseInt(urlParams.get('page')) || 1,
        index: parseInt(urlParams.get('index')) || 0
    }

    let href = loc.state ? loc.state.href : false;
    if (href) {
        wherestatement = loc.state.wherestatement;
    }

    useEffect(() => {
        const allItem = mamStatusList[0]; // All
        setSelectedMamStatus(allItem);
        setDataItem((prev) => ({ ...prev, MamStatus: null }));
        loadcombo();
        setShowArchived(false);
        doLoad ? setIsLoading(true) : setIsLoading(false);
        setPage({ skip: (paramQuery.curPage - 1) * page_take, take: page_take });
        loaddata({ per_page: page_take, current_page: paramQuery.curPage }, wherestatement, andWhereStatement, '', false);
    }, [props.entityname, props.gridData, props.title, props.wherestatement]);

    const onSearch = (e) => {
        e.preventDefault();
        let text = e.target.value?.trim();
        setSearchText(text);
    };

    // Search 
    useEffect(() => {
        if (searchText == null) return;
        let sortEvent = gridSort[0] ?? initialSort;
        if (searchText != "") {
            const timeOut = setTimeout(() => {
                setIsLoading(true);
                loaddata({ per_page: page.take, current_page: 1, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, searchText, showArchived);
            }, 700);
            return () => clearTimeout(timeOut);
        } else {
            setIsLoading(true);
            setPage({ skip: (paramQuery.curPage - 1) * page_take, take: page_take });
            loaddata({ per_page: page_take, current_page: paramQuery.curPage, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, searchText, showArchived);
        }
    }, [searchText]);

    useEffect(() => {
        if (gridRef.current && paramQuery.index >= 0) {
            let updateIndex = paramQuery.index > page_take ? paramQuery.index - ((paramQuery.curPage - 1) * page_take) : paramQuery.index;
            const gridElement = gridRef.current.element || gridRef.current.wrapper || gridRef.current;
            const contentArea = gridElement.querySelector('.k-grid-content');
            if (!contentArea) return;
            const rows = contentArea.querySelectorAll('tr');
            if (updateIndex < rows.length) {
                const targetRow = rows[updateIndex];
                const rowOffsetTop = targetRow.offsetTop;
                const contentAreaHeight = contentArea.clientHeight;
                const scrollPosition = rowOffsetTop - contentAreaHeight / 2 + targetRow.clientHeight / 2;
                contentArea.scrollTo({
                    top: scrollPosition,
                    behavior: 'smooth',
                });
            }
        }
    }, [paramQuery.index, gridData]);

    const loadcombo = async () => {

        const mediaCategoriesRes = await API.getDataLookup(ENTITYNAME.MediaCategory);
        setMediaCategories(mediaCategoriesRes.data);

        const mediaCategoryTypeRes = await API.getDataLookup(ENTITYNAME.MediaCategoryType);
        setMediaCategoryTypes(mediaCategoryTypeRes.data);

        const content = await API.getDataLookup(ENTITYNAME.Content, { sort: { Description: 1 }, query: ['Archive', '=', false] });
        setContents(content.data);

        let ingestPrototypeRes = await API.getDataLookup(ENTITYNAME.INGEST_PROTOTYPE, { sort: { SID: 1 } });
        setIngestPrototypes(ingestPrototypeRes.data);

        let transcodePrototypeRes = await API.getDataLookup(ENTITYNAME.TranscodePrototypes, { sort: { SID: 1 } });
        setTrancodePrototypes(transcodePrototypeRes.data);
    }

    const onChange = (e) => {
        setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    }

    const enterEdit = (item = {}) => {
        console.log("onEnterEdit");
        if (openNewEditForm === false) {
            setOpenForm(true);
            setEditItem(item);
        } else {
            let param = item.SID;
            let current_page = page.skip / page.take + 1;
            let prevPath = item.prevPath ?? 0;
            let state = {
                copy: item.copy ? true : false,
                quickEdit: item.quickEdit ? true : false,
                prevPath: loc.pathname + `?page=${current_page + prevPath}`,
                paths: [loc.pathname],
                pagination: `?page=${current_page + prevPath}`
            }
            navigate(`${param}?page=${current_page + prevPath}`, { state: state });
        }
    };

    const handleNavigate = (item) => {
        if (item?.Module) {
            window.open(item.path, "MyTargetWindowName");
        } else {
            navigate(`${item.path}`, { state: item });
        }
    }

    //onSubmit from EDITFORM
    const handleSubmit = async (dataItem, dataToSave) => {
        console.log("handleSUbmit");
        //if datatosave is null then dataitem is datasave
        dataToSave = dataToSave == null ? dataItem : dataToSave;

        let isDuplicate = await utility.checkDuplicate(props.entityname, dataToSave);

        if (!isDuplicate) {
            setOpenForm(true);
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.entry_already_exist_try_with_different_values_collection_error_message });
            return;
        }

        let res = await API.saveData(props.entityname, dataToSave);
        console.log(res);
        if (dataItem?.IsDefault) {
            await API.setAsDefault(entityName, dataItem?._id)
        }
        if (res.success) {
            if (showLogs) {
                let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: module, data: res.data, message: res.message };
                API.SaveLogs(logData);
            }
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
            return;
        }
        socket()?.emit(SOCKET_EVENTS.onSocketData, { action: SOCKET_ACTION.DELETE_LOCAL_STORAGE_KEY, module: MODULE.ALL, data: props.entityname })
        utility.deleteLocalStorageItem(props.entityname)
        //to load grid with new data
        loaddata({ per_page: page_take, current_page: 1 }, wherestatement, andWhereStatement, searchText, showArchived);
        setOpenForm(false);
    };

    const handleCancelEdit = () => {
        setOpenForm(false);
        mamID = null;
        const cleanUrl = window.location.href.split('?')[0];
        window.history.replaceState({}, '', cleanUrl);
    };

    const handleDelete = async (dataItem) => {
        console.log(dataItem);
        onConfirmDelete(dataItem)
    };

    const handleArchive = async (dataItem) => {
        console.log("Here");
        if (entityName == ENTITYNAME.Series || entityName == ENTITYNAME.Season) {
            var resArchiveUpdated = await API.onChangeArchiveInSeriesSeason({
                _id: dataItem._id,
                archive: !dataItem.Archive,
                entityName: entityName
            })
        } else {
            var resArchiveUpdated = await API.saveData(entityName, {
                ...dataItem,
                Archive: !dataItem.Archive
            })
        }

        if (resArchiveUpdated.success) {
            console.log(`Archive is been updated to ${!dataItem.Archive}`);
            if (module) {
                let logData = { event: !dataItem.Archive ? LOGEVENT.ARCHIVE : LOGEVENT.UNARCHIVE, module: module, data: { ...dataItem, Archive: !dataItem.Archive }, message: resArchiveUpdated.message };
                API.SaveLogs(logData);
            }
            let sortEvent = gridSort[0] ?? initialSort;
            let current_page = page.skip / page.take + 1;
            loaddata({ per_page: page_take, current_page: !dataItem.Archive ? current_page : 1, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, searchText, showArchived);
            socket()?.emit(SOCKET_EVENTS.onSocketData, { action: SOCKET_ACTION.DELETE_LOCAL_STORAGE_KEY, module: MODULE.ALL, data: props.entityname })
            utility.deleteLocalStorageItem(entityName);
        } else {
            console.log(resArchiveUpdated.message);
        }
    }

    // const onReIngestMAM = async (item) => {
    //     setShowSelectTransmissionTypePopup(true);
    //     setSelectedItem(item);
    // }

    // const createMAMAssetAndWO = async (data) => {

    //     setShowSelectTransmissionTypePopup(false);
    //     let payload = {
    //         mediaIds: [selectedItemsRef.current.MediaEpisode_id],
    //         entityName: ENTITYNAME.MediaEpisode,
    //         versionType: data.versionType._id,
    //         transmissionType: data.transmissionType,
    //         ingestPrototype: data.ingestProtoType,
    //     }

    //     let res = await API.createMAMandWoFromEpisodes(payload);

    //     if (res.success) {
    //         setSelectedItem([]);
    // ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: 'Successfully Re-Ingested!' });
    //     } else {
    // ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    //     }
    // }

    const onCloseUserPrefence = () => {
        let sortEvent = gridSort[0] ?? initialSort;
        loaddata({ per_page: page_take, current_page: 1, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, searchText, showArchived);
        setShowPreferences(!showPreferences);

    }

    const onShowMedia = async (data) => {
        console.log(data);
        let mediaEpisodeRes = await API.getData(ENTITYNAME.MediaEpisode, { query: ["_id", "=", data.MediaEpisode_id] });
        console.log(mediaEpisodeRes);
        if (!mediaEpisodeRes.success || mediaEpisodeRes.data.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Media not found !!" });
            return;
        }
        let mediaepisode = mediaEpisodeRes.data[0];
        if (mediaepisode?.SID > 0) {
            window.open(`/home/MediaEpisode/${mediaepisode?.MediaCategory?.Description}/${mediaepisode?.SID}`, { state: { copy: false } })
        } else {
            console.log('No Media attach');
            ToastNotification({ type: TOAST_TYPES.WARNING, title: lang.warning_message_title, message: lang.no_data_found_error_message });
        }
    }

    const setAsDefault = async (data) => {

        var setAsDefaultRes = await API.setAsDefault(entityName, data._id);
        if (setAsDefaultRes.success) {
            let sortEvent = gridSort[0] ?? initialSort;
            loaddata({ per_page: page_take, current_page: 1, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, searchText, showArchived);
            socket()?.emit(SOCKET_EVENTS.onSocketData, { action: SOCKET_ACTION.DELETE_LOCAL_STORAGE_KEY, module: MODULE.ALL, data: props.entityname })
            utility.deleteLocalStorageItem(entityName);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: setAsDefaultRes.message });
        }

    }

    const onCopyURL = (dataItem) => {
        if (!dataItem || !dataItem?.ImageUrl) {
            return;
        }
        navigator.clipboard.writeText(dataItem?.ImageUrl).then(() => {
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "URL copied successfully!" });
        }).catch((err) => {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        });
    };

    const OnShowAttachedMadia = async (dataItem) => {
        console.log(dataItem);
        setSelectedItem(dataItem)
        setShowAttachedMedia(true);
    }

    //Edit Row
    const MyCommandCell = (props) => (

        <MenuCommandCell
            {...props}
            showLogs={showLogs}
            enterEdit={enterEdit}
            cancelEdit={handleCancelEdit}
            onSubmit={handleSubmit}
            item={editItem}
            dataColumns={dataColumns}
            onArchive={handleArchive}
            toNavigate={handleNavigate}
            myMenuModel={myMenuModel}
            module={MODULE.MEDIA_EPISODE_MAMASSETS}
            setAsDefault={setAsDefault}
            onCopyURL={onCopyURL}
            isTieredMenu={isTieredMenu}
            OnShowMadia={onShowMedia}
            OnShowAttachedMadia={OnShowAttachedMadia}
        // onReIngestMAM={onReIngestMAM}
        />
    );



    const MyCustomToggleButton = (props) => (
        <MyToggleButton
            {...props}
            entityName={entityName}
            size={"small"}
            onGridDataUpdate={updateGridDataByIndex}
        />
    );

    const updateGridDataByIndex = (index, field, value) => {
        const updated = [...gridData];
        if (updated[index]) {
            updated[index] = { ...updated[index], [field]: value };
            setGridData(updated);
        }
    };

    const MyDatalookupCell = (props) => (
        <LookupCell {...props} dataColumns={dataColumns} />
    );

    const Mystatuscell = (props) => {
        const { dataItem } = props;

        let title = "";
        let tileBackColor = "";

        if (entityName === ENTITYNAME.PaymentProvider) {
            title = dataItem?.isActive ? "Active" : "Deactive";
            tileBackColor = dataItem?.isActive ? "#63aa43" : "#E72929";
        } else if (entityName === ENTITYNAME.OttProvider) {
            title = dataItem?.IsActive ? "Active" : "Deactive";
            tileBackColor = dataItem?.IsActive ? "#63aa43" : "#E72929";
        } else {
            title = dataItem?.CurrentStatus ?? "";
            tileBackColor = "#72eda9";
        }

        return (
            <MyStatusCell {...props} title={title} tileBackColor={tileBackColor} />
        );
    };

    const MyMultiLangArrayCell = (props) => (
        <MultiLangArrayCell selectedLang={selectedLanguageRef.current} {...props} />
    )

    const loaddata = async (pagination, wherestatement, andWhereStatement, searchText, archive, filters = []) => {

        let finalWhereStatementQuery = wherestatement;

        //HANDLE MAM STATUS FILTER
        if(filters.length == 0){
            if (selectedMamStatus?._id !== null && selectedMamStatus?._id > 1) {
                finalWhereStatementQuery = [...finalWhereStatementQuery, ["Status", "=", selectedMamStatus._id]];
            } else if (selectedMamStatus?._id === 1) {
                finalWhereStatementQuery = [
                    ...finalWhereStatementQuery,
                    ["Status", "!=", MAM_STATUS.Ingested], "and",
                    ["Status", "!=", MAM_STATUS.TXReady], "and",
                    ["Status", "!=", MAM_STATUS.Transcoding]
                ];
            }
        }

        if (props.gridColumns) {
            setDataColumns(props.gridColumns);
            setGridData(props.gridData);
            setIsLoading(false);
        } else {
            try {
                let currentUserId = utility.getValue(LOCALSTORAGE_KEY.user_id);
                let columns = await API.getFormData(preferenceColumnENntityName, currentUserId);
                let finalSort = pagination.direction ? { [pagination.orderby ?? 'SID']: pagination.direction == 'asc' ? 1 : -1 } : sort;
                let json = await API.getEntitiesWithSearch(
                    props.entityname,
                    { query: finalWhereStatementQuery, page: pagination.current_page, perPage: pagination.per_page, archive: archive, sort: finalSort },
                    columns,
                    searchText,
                    filters
                );
                setGridData(json?.data ?? []);
                setTotal(json?.pagination?.total);
                //if custmoe colum is coming from compemnent level then no need  a column from Server API
                customColumns.length > 0
                    ? setDataColumns(customColumns)
                    : setDataColumns(columns);

                // console.log(columns)
                setIsLoading(false);
                if (mamID) {
                    let mamData = json?.data?.length > 0 ? json?.data.find(x => x?.CSID === mamID) : {};
                    if (mamData?.CSID) {
                        setEditItem(mamData);
                        setOpenForm(true);
                    }
                }
            } catch (error) {
                console.log("error", error);
                setIsLoading(false);
                setIsNoRecords(true);
            }
        }
    };

    const handleErrorDialogClose = () => {
        setDeleteError(!deleteError);
        setDeleteErrorMessage("");
    }
    const errorHandler = (message) => {
        setWarningDialog(!warningDialog);
        setDeleteError(true);
        setDeleteErrorMessage(message);
    }

    const onConfirmDelete = async (dataItem) => {
        let res = { success: false, message: "" };
        switch (entityName) {
            case ENTITYNAME.DAI_CHANNELS:
                let user = utility.getValue(LOCALSTORAGE_KEY.userData);
                if (user?.RoleType?.ID == ROLETYPE.User) {
                    ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.dai_channel_delete_error_messgae });
                    return;
                }
                res = await API.daiChannelDelete(dataItem._id);
                break;
            default:
                await API.deleteData(props.entityname, dataItem.SID);
        }
        if (!res.success) {
            errorHandler(res.message);
            return;
        }
        let current_page = page.skip / page.take + 1;
        let sortEvent = gridSort[0] ?? initialSort;
        loaddata({ per_page: page.take, current_page: current_page, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, '', showArchived);
        socket()?.emit(SOCKET_EVENTS.onSocketData, { action: SOCKET_ACTION.DELETE_LOCAL_STORAGE_KEY, module: MODULE.ALL, data: props.entityname })
        utility.deleteLocalStorageItem(props.entityname);
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
    }

    const pageChange = async (e) => {
        let current_page = e.page.skip / e.page.take + 1;
        let sortEvent = gridSort[0] ?? initialSort;
        const url = new URL(window.location);
        url.searchParams.set('page', current_page);
        url.searchParams.set('index', 0);
        window.history.pushState({}, '', url);
        await loaddata({ per_page: e.page.take, current_page: current_page, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, searchText, showArchived);
        setPage(e.page);
        cancelSelectedItem();
    };

    const onArchiveClick = () => {
        setShowArchived(!showArchived);
        let sortEvent = gridSort[0] ?? initialSort;
        if (!showArchived) {
            loaddata({ per_page: page.take, current_page: 1, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, searchText, true);
        } else {
            let current_page = page.skip / page.take + 1;
            loaddata({ per_page: page.take, current_page: current_page, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, searchText, false);
        }
        cancelSelectedItem();
    }

    const refreshCollection = () => {
        setIsLoading(true);
        let current_page = page.skip / page.take + 1;
        loaddata({ per_page: page.take, current_page: current_page, orderby: "SID", direction: "asc" }, wherestatement, andWhereStatement, searchText, showArchived);
        setGridSort([initialSort]);
    }

    const onSortChange = (e) => {
        setGridSort(e.sort)
        let sortEvent = e.sort[0] ?? sort;
        let current_page = page.skip / page.take + 1;
        loaddata({ per_page: page.take, current_page: current_page, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, andWhereStatement, searchText, showArchived);
    }

    const downloadExcel = async () => {
        let currentUserId = utility.getValue(LOCALSTORAGE_KEY.user_id);
        let columns = await API.getFormData(preferenceColumnENntityName, currentUserId);
        let dataRes = await API.getEntitiesWithSearch(
            props.entityname,
            { per_page: null, current_page: null, query: wherestatement, archive: showArchived },
            columns,
            searchText
        );
        if (dataRes?.success && dataRes?.data?.length == 0) {
            ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: lang.no_data_found_error_message });
            return;
        }

        let res = await API.exportGridExcel(dataRes?.data, dataColumns, preferenceColumnENntityName);
        if (res.success) {
            window.open(FILEURL().BASEURL + 'downloadReport/' + res.data)
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_download_success_message });
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    const onSelectionChange = (event) => {
        const newSelectedState = getSelectedState({
            event,
            selectedState: selectedState,
            dataItemKey: DATA_ITEM_KEY,
        });
        setSelectedState(newSelectedState);

        let selectedIds = Object.keys(newSelectedState);
        let tempSelected = [];

        selectedIds.map((value) => {
            if (newSelectedState[value]) {
                let filter = gridData.find((obj) => obj._id == value);
                tempSelected.push(filter);
            }
        });

        setSelectedItem(tempSelected);
    };


    const onHeaderSelectionChange = (event) => {
        const checkboxElement = event.syntheticEvent.target;
        const checked = checkboxElement.checked;
        const newSelectedState = {};
        event.dataItems.forEach((item) => {
            newSelectedState[idGetter(item)] = checked;
        });
        setSelectedState(newSelectedState);

        var selectedIds = Object.keys(newSelectedState);
        var tempSelected = [];

        if (checked) {
            selectedIds.map((value) => {
                if (newSelectedState[value]) {
                    var filtered = gridData.find((obj) => obj._id == value);
                    tempSelected.push(filtered);
                }
            });
        }
        setSelectedItem(tempSelected);
    };

    const onArchiveButtonClick = async () => {
        if (selectedItemsRef.current.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_atleast_one_item });
            return;
        }

        ConfirmAlert(
            async () => {
                for (let i = 0; i < selectedItemsRef.current.length; i++) {
                    const item = selectedItemsRef.current[i];
                    await handleArchive(item);
                    cancelSelectedItem();
                }
            },
            () => { cancelSelectedItem(); },
            !showArchived ? "Archive Confirmation !" : "Unarchive Confirmation !",
            !showArchived ? "Are you sure you want to archive the selected items?" : "Are you sure you want to unarchive the selected items?"
        );
    }
    const isValidTranscodeWO = () => {
        if (selectedItemsRef.current.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_atleast_one_item });
            return false;
        }
        if (selectedItemsRef.current.some((x) => x.Status == MAM_STATUS.TXReady)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.some_spots_are_txready_selected_spots_error_message });
            return;
        }
        return true;
    }

    const onTransCodingWOButtonClick = async (currentPrototype) => {
        const mamIds = selectedItemsRef.current.map(x => x._id);
        let res = await API.createTranscodeWorkOrder({ mamIds, transcodePrototype: currentPrototype });
        console.log(res);
        if (res.success) {
            setTranscodePrototype({});
            setShowTranscodePrototypePopup(false);
            cancelSelectedItem();

            let results = [];
            let updatedIds = {};

            if (res.data && Array.isArray(res.data)) {
                res.data.forEach(item => {
                    const isSuccess = item.success;
                    results.push({
                        fileName: item.data || "Unknown File",
                        success: isSuccess,
                        messageTitle: item.messageTitle || (isSuccess ? "Upload Successful" : "Upload Failed"),
                        message: isSuccess ? "" : (item.message || "")
                    });

                    if (item.mamId) {
                        updatedIds[item.mamId] = { success: isSuccess };
                    }
                });
            }

            if (Object.keys(updatedIds).length > 0) {
                setGridData(prevData => prevData.map(mam => {
                    if (updatedIds[mam._id]?.success) {
                        return { ...mam, Status: MAM_STATUS.Transcoding };
                    }
                    return mam;
                }));
            }

            if (results.length > 0) {
                setPublishResultsTitle("Transcode Work Order Results");
                setPublishResults(results);
                setShowPublishResultsPopup(true);
            }
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }


    const handleTranscodingWO = () => {
        if (selectedItemsRef.current.length == 0) {
            ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: "Please select atleast one item" });
            return;
        }
        if (selectedItemsRef.current.length == 1 && selectedItemsRef.current[0].TranscodePrototype) {
            setAttachedTranscodePrototype(selectedItemsRef.current[0].TranscodePrototype);
            setTranscodePrototype({});
        } else {
            setAttachedTranscodePrototype(null);
            if (transcodePrototypes && transcodePrototypes.length > 0) {
                setTranscodePrototype(transcodePrototypes[0]);
            } else {
                setTranscodePrototype({});
            }
        }
        setShowTranscodePrototypePopup(true);
    }
    const handleIngestPrototype = () => {
        if (selectedItemsRef.current.length == 0) {
            ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: "Please select atleast one item" });
            return;
        }
        if (selectedItemsRef.current.length == 1 && selectedItemsRef.current[0].IngestPrototype) {
            setAttachedIngestPrototype(selectedItemsRef.current[0].IngestPrototype);
            setIngestPrototype({});
        } else {
            setAttachedIngestPrototype(null);
            if (ingestPrototypes && ingestPrototypes.length > 0) {
                setIngestPrototype(ingestPrototypes[0]);
            } else {
                setIngestPrototype({});
            }
        }
        // Also load attached transcode prototype for the transcode tab
        if (selectedItemsRef.current.length == 1 && selectedItemsRef.current[0].TranscodePrototype) {
            setAttachedTranscodePrototype(selectedItemsRef.current[0].TranscodePrototype);
        } else {
            setAttachedTranscodePrototype(null);
        }
        setShowSelectTransmissionTypePopup(true);
    };

    const onIngestPrototype = async (prototypeData) => {
        // prototypeData is { ingestPrototype, transcodePrototype } from the tabbed dialog
        const currentPrototype = prototypeData?.ingestPrototype;
        const currentTranscodePrototype = prototypeData?.transcodePrototype;
        console.log("currentPrototype", currentPrototype);
        console.log("currentTranscodePrototype", currentTranscodePrototype);
        if (!currentPrototype || Object.keys(currentPrototype).length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please select an Ingest prototype" });
            return;
        }

        if (selectedItemsRef.current.length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_atleast_one_item });
            return;
        }

        setShowSelectTransmissionTypePopup(false);
        try {
            let areAllPending = true;
            const mamIds = selectedItemsRef.current.filter(m => m != null && m._id).map(x => {
                if (x.Status != MAM_STATUS.Pending) {
                    areAllPending = false;
                }
                return x._id;
            });

            if (!areAllPending) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Only items that are still pending are eligible to be sent to the ingestion work order." });
                return;
            }
            const payload = { mamIds, entityName: ENTITYNAME.MediaMamAssets, ingestPrototype: currentPrototype, transcodePrototype: currentTranscodePrototype };

            console.log("calling createMamIngestWorkOrders");
            const res = await API.createMamIngestWorkOrders(payload);

            if (res.success) {
                cancelSelectedItem();

                let results = [];
                let updatedIds = {};

                if (res.data && Array.isArray(res.data)) {
                    res.data.forEach(item => {
                        const isSuccess = item.fileUploadRes ? item.fileUploadRes.success : true;
                        results.push({
                            fileName: item.fileName || "Unknown File",
                            success: isSuccess,
                            messageTitle: isSuccess ? "Published Successfully" : (item.fileUploadRes?.messageTitle || "Publish Failed"),
                            message: isSuccess ? "" : (item.fileUploadRes?.message || "")
                        });

                        if (item.mamId) {
                            updatedIds[item.mamId] = { success: isSuccess, status: item.status };
                        }
                    });
                }

                if (Object.keys(updatedIds).length > 0) {
                    setGridData(prevData => prevData.map(mam => {
                        if (updatedIds[mam._id]?.success) {
                            return { ...mam, Status: updatedIds[mam._id].status, IngestPrototype: currentPrototype, TranscodePrototype: currentTranscodePrototype };
                        }
                        return mam;
                    }));
                }

                if (results.length > 0) {
                    setPublishResultsTitle("Ingest Work Order Results");
                    setPublishResults(results);
                    setShowPublishResultsPopup(true);
                }

            } else {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
            }
        } catch (err) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: err.message });
        }
    };

    const onTranscodingWO = async (prototypeData) => {
        let currentPrototype = prototypeData;
        console.log("currentTranscodePrototype", currentPrototype);

        if (!currentPrototype || Object.keys(currentPrototype).length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please select a transcoding prototype" });
            return;
        }

        if (!isValidTranscodeWO()) return;

        setShowTranscodePrototypePopup(false);

        if (selectedItemsRef.current?.some((x) => x.Status == MAM_STATUS.Transcoding)) {
            ConfirmAlert(
                async () => onTransCodingWOButtonClick(currentPrototype),
                () => { },
                lang.transcoding_work_order_confirmation_message,
                lang.transcoding_work_order_confirmation_text
            )
        } else {
            onTransCodingWOButtonClick(currentPrototype);
        }
    }

    const onEnterEdit = () => {
        enterEdit({ SID: 0 });
        cancelSelectedItem();
    }

    const cancelSelectedItem = () => {
        setSelectedItem([]);
        setSelectedState({});
    }

    let timeOut;
    const handleColumnResize = (event) => {
        let lockedCol = event.columns.filter((item) => item?.locked).length ?? 1;
        try {
            if (event.index == 0) return;
            if (dataColumns == undefined || dataColumns.length == 0 || dataColumns.length < event.index) return;
            let column = dataColumns[event.index - lockedCol];
            let payload = {
                entityName: column?.entityName,
                name: column?.name,
                width: event.newWidth
            };
            clearTimeout(timeOut);
            timeOut = setTimeout(() => {
                API.updateUserPreferenceColumnWidth(payload);
            }, 700);
        } catch (error) {
            console.error("Error handling column resize:", error);
        }
    };

    //SYNC MAM ASSET
    const syncMAMAsset = async () => {

        if (gridData.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_data_found_error_message });
            return;
        }

        let res = await API.syncMAMDataWithMediaEpisode();
        if (res.success) {
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    //S3 BUCKET SYNC
    const onSyncMAMAssetWithS3Bucket = async () => {

        let res = await API.syncMAMFromS3();
        if (res.success) {
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
            loaddata({ per_page: page_take, current_page: paramQuery.curPage }, wherestatement, andWhereStatement, '', false);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }

    }

    const onImportMamAssetToMedia = async () => {

        if (!dataItem.MediaCategory || Object.keys(dataItem.MediaCategory).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_media_category_error_message });
            return;
        }

        if (!dataItem.MediaCategoryType || Object.keys(dataItem.MediaCategoryType).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_media_category_type_error_message });
            return;
        }

        if (selectedMamAssets.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_atleast_one_item });
            return;
        }

        //DATA TO SAVE
        let dataToSave = selectedMamAssets.map((item) => {

            let obj = {
                SID: 0,
                AssetId: item?.Title,
                Title: item?.Title,
                Content: contents.find((obj) => obj.MediaCategoryType.SID == dataItem.MediaCategoryType.SID) ?? contents[0],
                Description: item?.Title,
                MediaCategory: dataItem?.MediaCategory,
                MediaCategoryType: dataItem?.MediaCategoryType,
                TcIn: "00:00:00:00",
                TcOut: utility.convertMilisecondsToStringWithFrames(item?.ActualDuration),
                Duration: utility.convertMilisecondsToStringWithFrames(item?.ActualDuration),
                BroadcasterId: item?.AssetId,
                Transmission: { _id: MEDIA_TRANSMISSION.READY, Description: utility.getKeyByValue(MEDIA_TRANSMISSION, MEDIA_TRANSMISSION.READY) }
            }

            return DataHelper.saveMediaEpisodeIsShortFormEntity(obj);
        });

        console.log(dataToSave)

        //SAVE MAM ASSET
        let res = await API.saveData(ENTITYNAME.MediaEpisode, dataToSave);

        //UPDATE STATUS

        console.log(res)
        if (res.success) {
            let updatedData = res.data.map((item, i) => {
                return item.success ?
                    { ...selectedMamAssets[i], Status: "Imported" } :
                    { ...selectedMamAssets[i], Status: "Already Exists with same Asset Id " }
            })
            setSelectedMamAssets(updatedData);
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message });
            closeMoveMamAssetPopup();
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }

    }

    const onBrowseMamAsset = (datalist) => {

        let mamAssetData = datalist.map((obj) => {
            return { ...obj, Status: "Pending" }
        })

        //CHECK DUPLICATE
        const selectedIds = new Set(selectedMamAssets?.map(item => item?.AssetId));

        let duplicate = [];
        let newData = [];

        mamAssetData?.forEach(obj => {
            if (selectedIds.has(obj?.AssetId)) {
                duplicate.push(obj);
            } else {
                newData.push(obj);
            }
        });

        if (duplicate.length > 0) {
            ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: `${duplicate.map(x => x.Title).join(', ')} are already exists` });
        }

        setSelectedMamAssets([...selectedMamAssets, ...newData]);

    }

    const removeMamAssets = (index) => {

        console.log(index)
        if (selectedMamAssets.length == 1) {
            setSelectedMamAssets([]);
        } else {
            // console.log(index);
            setSelectedMamAssets([
                ...selectedMamAssets.slice(0, index),
                ...selectedMamAssets.slice(index + 1, selectedMamAssets.length)
            ]);

        }
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.delete_successfully_grid_data_success_toast_message });
    }

    const MyColSelCommandCell = (props) => (
        <div className="" style={{ padding: "1.5px" }}>
            <DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => removeMamAssets(props.dataIndex), () => { })} />
        </div>
    )

    const closeMoveMamAssetPopup = () => {
        setShowMoveToMediaPopup(false);
        setSelectedMamAssets([]);
        setDataItem({});
    }

    const importMAMAssetsViaExcel = async (e) => {
        const file = e.target.files?.[0];

        if (!file) return;

        const res = await API.importMAMAssetsViaExcel(file);

        if (res.success) {
            console.log(res)
            refreshCollection();
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.import_mam_asset_success_message });
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
        e.target.value = null;
    };

    const downloadMAMAssetTemplate = () => {
        try {
            let filePath = FILEURL().BASEURL + 'downloadTemplate/' + TEMPLATENAME.MAMAssetImportTemplate;
            window.open(filePath);
        } catch (error) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.error_downloading_template_booking_error_message });
        }
    }

    const setMamStatusAsPending = async (items = []) => {
        if (items.length == 0) {
            ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: "Please select atleast one item" });
            return;
        }
        cancelSelectedItem();
        let res = await API.saveData(ENTITYNAME.MediaMamAssets, items.map(item => {
            return { ...item, Status: MAM_STATUS.Pending, IngestPrototype: {}, TranscodePrototype: {} }
        }))
        if (res.success) {
            let updatedMamAssetsId = [];
            res.data.map(item => {
                if (item.success) {
                    updatedMamAssetsId.push(item.data._id);
                }
            })
            setGridData(gridData.map(item => {
                if (updatedMamAssetsId.some(id => id == item?._id)) {
                    return { ...item, Status: MAM_STATUS.Pending, IngestPrototype: {}, TranscodePrototype: {} }
                }
                return item;
            }));
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "Mam status set to pending" });
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Something went wrong" });
        }
    }

    const menuModel = [
        {
            label: lang.work_order_button_tooltip,
            icon: 'fa fa-file-import',
            items: [
                {
                    label: lang.ingest_Work_order_label,
                    icon: 'fa fa-indent',
                    command: handleIngestPrototype,
                },
                {
                    label: lang.transcoding_Work_order_label,
                    icon: 'fa fa-globe',
                    command: handleTranscodingWO,
                },
            ]
        },
        {
            label: lang.set_mam_status_as_pending_label,
            icon: 'fa fa-edit',
            command: async () => { await setMamStatusAsPending(selectedItemsRef.current) },
        },
        showSyncMaMAsset && {
            label: lang.sync_mam_asset_label,
            icon: 'fa fa-squarespace',
            command: syncMAMAsset,
        },
        showSyncWithS3MaMAsset && {
            label: lang.sync_mam_asset_with_S3_label,
            icon: 'fa fa-box',
            command: onSyncMAMAssetWithS3Bucket,
        },
        {
            label: lang.move_to_media_management_label,
            icon: 'fa fa-arrow-right-to-bracket',
            command: () => { setShowMoveToMediaPopup(true) },
        },
        {
            label: lang.import_label,
            icon: 'fa fa-download',
            items: [
                {
                    label: lang.import_label,
                    icon: 'fa fa-file-arrow-down',
                    command: () => fileRef.current.click(),
                },
                {
                    label: lang.download_template_label,
                    icon: 'fa fa-download',
                    command: downloadMAMAssetTemplate,
                },
            ],
        },
        showArchive && enableMutliSelect && selectedItemsRef.current.length != 0 && {
            label: showArchived ? lang.un_archive_label : lang.archive,
            icon: 'fa fa-inbox',
            command: onArchiveButtonClick,
        },
    ].filter(Boolean);
    return (
        <>
            <div>
                {showTitle && (
                    <h1 className="page-title txt-color-bludeDark">
                        <i
                            className="fa fa-table marlr"
                            style={{ fontSize: "20px", color: "GrayText" }}
                        ></i>
                        <span>{myTitle === "" ? props.entityname : myTitle}</span>
                    </h1>
                )}
                <div className="flex-container">
                    <div className="martb mar">
                        {showBack && (
                            <BackRoundButton onClick={() => navigate(-1)}></BackRoundButton>
                        )}
                        {showAdd && (
                            <AddRoundButton onClick={onEnterEdit}></AddRoundButton>
                        )}
                        <div style={{ display: "inline" }}>
                            <RoundButton icon="ellipsis" title={lang.context_menu_label} onClick={(e) => menuRef.current.show(e)} />
                            <ContextMenu
                                ref={menuRef}
                                model={menuModel}
                            />
                        </div>

                        <input
                            ref={fileRef}
                            type="file"
                            name="mamAsset"
                            accept=".xlsx,.xls"
                            onChange={importMAMAssetsViaExcel}
                            style={{ display: 'none' }}
                        />
                    </div>
                    <div className="flex-container-reverse flex-item-auto">

                        <div className="input-group input-group w-300 martb" >
                            <input
                                type="text"
                                className="form-control shadow-inset-2 pt-0 pb-0"
                                id="searchInput"
                                placeholder={lang.search_button_text}
                                onChange={onSearch}
                                onFocus={(e) => {
                                    if (props.setOutSideFocus) {
                                        props.setOutSideFocus(true);
                                    }
                                }}
                                onBlur={(e) => {
                                    if (props.setOutSideFocus) {
                                        props.setOutSideFocus(false);
                                    }
                                }}
                            />
                        </div>

                        {showPreferenceButton && <div className="m-1" style={{ paddingTop: "12px" }}>
                            <PreferenceRoundButton
                                icon={"gear"}
                                title={lang.preference_button_tooltip}
                                onClick={() => { setShowPreferences(!showPreferences) }}
                            />
                        </div>}
                        <div className="mt-1" style={{ paddingTop: "12px" }}>
                            <RefreshButton onClick={refreshCollection} />
                        </div>
                        {showImport && (
                            <div className="mt-1" style={{ paddingTop: "12px" }}>
                                <RoundButton
                                    icon={"upload"}
                                    btnColor={"warning"}
                                    // style={{ margin: "0px 03px" }}
                                    // iconColor={"white"}
                                    title={lang.import_file_label}
                                    onClick={() => { }}
                                // onClick={() => navigate('/home/DataMigration', { state: { mediaCategory: props.mediaCategory } })} //route navigate to data migration module
                                /></div>
                        )}
                        {showExport && (
                            <div className="m-1" style={{ paddingTop: "12px" }}>
                                <RoundButton
                                    icon={"download"}
                                    btnColor={"info"}
                                    style={{ color: 'white' }}
                                    // iconColor={"white"}
                                    title={lang.export_button_tooltip}
                                    onClick={downloadExcel}
                                /></div>
                        )}

                        {!hideArchive && <div className="d-inline mt-4 mr-2">
                            <input type='checkbox' name='FilteredArchive' checked={showArchived} onClick={onArchiveClick} onChange={() => { }} />  {lang.archive}
                        </div>}
                        {showLangDropdown && (<DropDownList
                            data={mamStatusList}
                            style={{
                                backgroundColor: 'white',
                                width: '200px',
                                height: '38px',
                                margin: '10px'
                            }}
                            textField="Description"
                            dataItemKey="_id"
                            value={selectedMamStatus}
                            onChange={handleMamStatusChange}
                        />)}
                    </div>
                </div>
                {isLoading && <Loader />}
                {isNoRecords && <div style={{ margin: "0px 500px" }}><h4><strong>{lang.no_records_found}</strong></h4></div>}
                {!isLoading && !isNoRecords &&
                    <Grid
                        style={props.gridstyle ?? {
                            height: "76vh",
                        }}
                        ref={gridRef}
                        sort={gridSort}
                        sortable={sortable}
                        onSortChange={onSortChange}
                        rowRender={gridRowRender}
                        filterable={filterable}
                        pageable={isPageable}
                        skip={page.skip}
                        take={page.take}
                        onPageChange={pageChange}
                        total={total}
                        resizable={true}
                        onColumnResize={handleColumnResize}
                        data={
                            gridData.map((item) => ({
                                ...item,
                                [SELECTED_FIELD]: selectedState[idGetter(item)],
                            }))}
                        selectedField={SELECTED_FIELD}
                        selectable={{
                            enabled: enableMutliSelect,
                            drag: false,
                            cell: false,
                            mode: "multiple",
                        }}
                        dataItemKey={DATA_ITEM_KEY}
                        onSelectionChange={onSelectionChange}
                        onHeaderSelectionChange={onHeaderSelectionChange}
                    >

                        {/* Multi Select Checkbox row */}
                        {enableMutliSelect && (<GridColumn
                            field={SELECTED_FIELD}
                            width="50px"
                            headerSelectionValue={
                                gridData.findIndex(
                                    (item) => !selectedState[idGetter(item)]
                                ) === -1
                            }
                            locked={true}
                            filterable={false}
                        />
                        )}

                        {/* Edit Row */}
                        {showCommandCell && (
                            <GridColumn cell={MyCommandCell} width={"60px"} locked={true} resizable={false} />
                        )}

                        {/* Rows Loop */}
                        {dataColumns.map((column, index) => {
                            if (column.type === COLUMNSTYPE.date) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={DateOnlyCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={true}
                                    />
                                );
                                // }else if (column.name === COLUMNSTYPE.time) {
                            } else if (column.type === COLUMNSTYPE.datetime) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={DateCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={true}
                                    />
                                );
                                // }else if (column.name === COLUMNSTYPE.time) {
                            } else if (column.name.includes("Duration") || column.type == COLUMNSTYPE.time) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={TimeCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={true}
                                    />
                                );
                            } else if (column.name === "Status" && column.type == COLUMNSTYPE.mamAssetStatusCell) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={MAMStatusCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={false}
                                    />
                                );
                            } else if (column.type === COLUMNSTYPE.image) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={(p) => ImageCell({ ...p, title: column.label })}
                                        title={column.label}
                                        width={column.width ?? 100}
                                        sortable={false}
                                    />
                                );
                            } else if (column.type === COLUMNSTYPE.select) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={MyDatalookupCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.toggle) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={MyCustomToggleButton}
                                        title={column.label}
                                        width={85}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.checkbox) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={CheckboxCell}
                                        title={column.label}
                                        width={column.width ?? 80}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.array) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={ArrayCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        format={column.format ?? "Description"} //display item in object
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.href) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={HrefCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        format={column.format}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.hyperlink) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={HyperLinkCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        format={column.format}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.enum) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={EnumCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        format={column.format ?? "Description"} //display item in object
                                        sortable={true}
                                    />
                                );
                            } else if (column.type === COLUMNSTYPE.platform) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={PlatformCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={false}
                                    />
                                );
                            } else if (column.type === COLUMNSTYPE.status) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={Mystatuscell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.localdatetime) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={LocalDateTimeColumn}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={true}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.icon) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={IconCell}
                                        title={column.label}
                                        width={column.width ?? 80}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.arrayenum) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={arrayEnumCell}
                                        title={column.label}
                                        width={column.width ?? 80}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.color) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={colorCell}
                                        title={column.label}
                                        width={column.width ?? 80}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.day) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={daysCell}
                                        title={column.label}
                                        width={column.width ?? 80}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.multiLangCell) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={MyMultiLangArrayCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.textWithIcon) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={TextWithIconCell}
                                        title={column.label}
                                        width={column.width ?? 200}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.imageArrayCell) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={ContentArrayImageCell}
                                        title={column.label}
                                        width={column.width ?? 350}
                                        sortable={false}
                                    />
                                );
                            }
                            else if (column.type === COLUMNSTYPE.castType) {
                                return (
                                    <GridColumn
                                        key={index}
                                        field={column.name}
                                        cell={castTypeCell}
                                        title={column.label}
                                        width={column.width ?? 80}
                                    />
                                );
                            }
                            else {
                                return (
                                    column.type !== COLUMNSTYPE.hidden && (
                                        <GridColumn
                                            key={index}
                                            field={column.name}
                                            title={column.label}
                                            width={column.width ?? 200}
                                            sortable={true}
                                        />
                                    )
                                );
                            }
                        })}
                    </Grid>}
            </div>

            {openForm && (
                <CustomEditForm
                    {...props} //to get other props from customEditForm
                    cancelEdit={handleCancelEdit}
                    onSubmit={handleSubmit}
                    refresh={refreshCollection}//to refresh the collection when data added
                    item={editItem}
                    dataColumns={dataColumns}
                />
            )}

            {
                deleteError &&
                <DeleteErrorDialogBox message={deleteErrorMessage} onClose={handleErrorDialogClose} title={`Error Deleting - ${props.title}`} />
            }
            {showPreferences && <UserPreference entityName={entityName} preferenceColumnENntityName={props.preferenceEntityName} handleClose={onCloseUserPrefence} />}

            {/* MOVE TO MEDIA MANAGEMENT */}
            {
                showMoveToMediaPopup && <BossDialog
                    title={lang.move_to_media_management_label}
                    onClose={closeMoveMamAssetPopup}
                    width={"41vw"}
                >
                    <ActionButton name={lang.import_label} onClick={onImportMamAssetToMedia} style={{ margin: 0 }} />
                    <div className="row" style={{ marginTop: '10px' }}>

                        <div className="col-6" style={{ width: '200px' }}>

                            <label className="">{lang.media_category_label} *</label>
                            <DropDownList
                                data={mediaCategories.filter((x) => !x.isLong)}
                                name="MediaCategory"
                                dataItemKey="_id"
                                textField="Description"
                                onChange={onChange}
                                value={dataItem.MediaCategory}
                                style={{ backgroundColor: 'white', height: '32px' }}
                            />
                        </div>
                        <div className="col-6" style={{ width: '200px' }}>
                            <label className="">{lang.media_category_type_label} *</label>
                            <DropDownList
                                data={mediaCategoryTypes.filter((x) => dataItem.MediaCategory && x.MediaCategorySID == dataItem.MediaCategory.SID)}
                                name="MediaCategoryType"
                                dataItemKey="_id"
                                textField="Description"
                                onChange={onChange}
                                value={dataItem.MediaCategoryType}
                                style={{ backgroundColor: 'white', height: '32px' }}
                            />
                        </div>
                    </div>
                    <div style={{ marginTop: '15px' }}>
                        <div className="row">
                            <div className="col">
                                <RoundButton title={lang.add_mam_asset_label} icon={"plus"} onClick={() => { setShowMamAssetCollectionSelection(true) }} />
                                <DeleteRoundButton title={lang.delete_all_button_tooltip} btnColor={"danger"} iconColor={"white"} onClick={() => ConfirmDeleteAlert(() => setSelectedMamAssets([]), () => { })} />
                            </div>
                            <div className="col">
                                <p className="muted" style={{ color: "grey", textAlign: 'right', fontSize: "15px", paddingTop: "7px", margin: 0 }}>{lang.mam_assets_label}</p>
                            </div>
                        </div>
                        <Grid data={selectedMamAssets} style={{ height: '300px' }} resizable={true}>
                            <GridColumn cell={MyColSelCommandCell} width={"35px"} locked={true} />
                            <GridColumn field="Title" title={lang.title_label} width="200" />
                            <GridColumn field="Title" title={lang.asset_id_label} width="200" />
                            <GridColumn field="ActualDuration" title={lang.actual_duration_label} width="200" cell={TimeCell} />
                            <GridColumn field="AssetId" title={lang.reference_code_label} width="200" />
                            <GridColumn field="Status" title={lang.status_label} width="200" />
                        </Grid>
                        <div className="row mt-1">
                            {/* <div className="col text-muted" style={{ fontSize: "11px" }}>{`${note}`}</div> */}
                            <div className="col text-right">{`${lang.total_label} : ${selectedMamAssets.length}`}</div>
                        </div>
                    </div>

                </BossDialog>
            }

            {
                showMamAssetCollectionSelection &&
                <CollectionSelection
                    entityname={ENTITYNAME.MediaMamAssets}
                    customColumns={MediaMamAssetColumns}
                    title={lang.attach_mam_asset_tooltip}
                    closeForm={() => setShowMamAssetCollectionSelection(false)}
                    wherestatement={props.wherestatement ?? ""}
                    setDataList={onBrowseMamAsset}
                    width={"50vw"}
                />
            }
            {/* {showSelectTransmissionTypePopup && <MediaEpisodeIngestMAMPopup createMAMAssetAndWO={createMAMAssetAndWO} onClose={() => { setShowSelectTransmissionTypePopup(false) }} />} */}

            {
                showSelectTransmissionTypePopup && <PrototypeDialog
                    mode="ingest"
                    onClose={() => setShowSelectTransmissionTypePopup(false)}
                    onSubmit={(data) => onIngestPrototype(data)}
                    data={ingestPrototypes}
                    value={ingestPrototype}
                    onChange={setIngestPrototype}
                    initialData={attachedIngestPrototype}
                    transcodePrototypesData={transcodePrototypes}
                    initialTranscodeData={attachedTranscodePrototype}
                />
            }

            {
                showTranscodePrototypePopup && <PrototypeDialog
                    mode="transcode"
                    onClose={() => setShowTranscodePrototypePopup(false)}
                    onSubmit={(data) => onTranscodingWO(data)}
                    data={transcodePrototypes}
                    value={transcodePrototype}
                    onChange={setTranscodePrototype}
                    initialData={attachedTranscodePrototype}
                />
            }
            {showPublishResultsPopup && (
                <div style={{
                    position: 'fixed',
                    top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    zIndex: 99999,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    animation: 'fadeIn 0.2s ease-out'
                }}>
                    <div style={{
                        background: '#ffffff',
                        borderRadius: '8px',
                        width: '600px',
                        maxWidth: '90vw',
                        maxHeight: '85vh',
                        boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
                        overflow: 'hidden',
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        {/* Header */}
                        <div style={{
                            padding: '16px 24px',
                            backgroundColor: '#ffffff',
                            borderBottom: '1px solid #eaeaea',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <i className="fas fa-tasks" style={{ fontSize: '18px', color: '#0d6efd' }}></i>
                                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#333' }}>
                                    {publishResultsTitle}
                                </h3>
                            </div>
                            <button
                                onClick={() => setShowPublishResultsPopup(false)}
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                    color: '#999',
                                    fontSize: '22px',
                                    cursor: 'pointer',
                                    padding: '0 4px',
                                    lineHeight: '1'
                                }}
                            >
                                &times;
                            </button>
                        </div>

                        {/* Body - Compact List */}
                        <div style={{
                            padding: '0',
                            overflowY: 'auto',
                            backgroundColor: '#ffffff',
                            flex: 1
                        }}>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                {publishResults.map((result, idx) => (
                                    <div key={idx} style={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        padding: '12px 24px',
                                        borderBottom: '1px solid #f0f0f0',
                                        backgroundColor: result.success ? '#ffffff' : '#fffcfc'
                                    }}>
                                        {result.success ? (
                                            <i className="fas fa-check-circle" style={{ color: '#198754', fontSize: '16px', marginTop: '3px', marginRight: '12px' }}></i>
                                        ) : (
                                            <i className="fas fa-times-circle" style={{ color: '#dc3545', fontSize: '16px', marginTop: '3px', marginRight: '12px' }}></i>
                                        )}
                                        <div style={{ flex: 1, minWidth: 0 }}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '2px' }}>
                                                <span style={{ fontWeight: '500', color: '#333', fontSize: '14px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                    {result.fileName}
                                                </span>
                                                <span style={{
                                                    fontSize: '12px',
                                                    fontWeight: '500',
                                                    color: result.success ? '#198754' : '#dc3545',
                                                    marginLeft: '12px',
                                                    whiteSpace: 'nowrap'
                                                }}>
                                                    {result.messageTitle}
                                                </span>
                                            </div>
                                            {!result.success && result.message && (
                                                <div style={{
                                                    color: '#666',
                                                    fontSize: '12px',
                                                    fontFamily: 'monospace',
                                                    wordBreak: 'break-all',
                                                    marginTop: '4px',
                                                    lineHeight: '1.4'
                                                }}>
                                                    {result.message}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Footer */}
                        <div style={{
                            padding: '12px 24px',
                            backgroundColor: '#fafafa',
                            borderTop: '1px solid #eaeaea',
                            display: 'flex',
                            justifyContent: 'flex-end'
                        }}>
                            <button
                                onClick={() => setShowPublishResultsPopup(false)}
                                style={{
                                    backgroundColor: '#ffffff',
                                    color: '#333',
                                    border: '1px solid #ccc',
                                    padding: '6px 16px',
                                    borderRadius: '4px',
                                    fontSize: '13px',
                                    fontWeight: '500',
                                    cursor: 'pointer'
                                }}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {showAttachedMedia && <MamAssetShowAttachedMediaForm onClose={() => { setShowAttachedMedia(false) }} mamItem={selectedItemsRef.current} />}
        </>
    );
};
